import React, { useState } from "react";
import PropTypes from "prop-types";

import { useMutation } from "react-apollo";

import { Fieldset } from "rbx";

import {
  UPDATE_NOTE_MUTATION,
  DELETE_NOTE_MUTATION
} from "../../graphql/Notes/Notes.graphql";

import { ourToast as toast } from "../../utils";

import { EditFormButtonGroup } from "../inputs";

import CustomerNoteForm from "./CustomerNoteForm";

const EditCustomerNoteForm = ({ note, onComplete }) => {
  const [inputs, setInputs] = useState({ ...note });

  const [updateNote, { loading }] = useMutation(UPDATE_NOTE_MUTATION);
  const handleSubmit = async e => {
    e.preventDefault();
    try {
      await updateNote({
        variables: {
          data: {
            TableName: "Customers",
            NoteTypeRecIdRef: parseInt(inputs.NoteTypeRecIdRef),
            Note: inputs.Note
          },
          where: {
            RecId: note.RecId
          }
        }
      });
      toast.success("Note added successfully.");
      onComplete();
    } catch (err) {
      toast.error("Error adding Note.");
    }
  };
  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setInputs({ ...inputs, [e.target.name]: value });
  };
  return (
    <form id="edit-customer-note-form" method="POST" onSubmit={handleSubmit}>
      <Fieldset disabled={loading}>
        <CustomerNoteForm inputs={inputs} onChange={handleChange} />
        <hr />
        <EditFormButtonGroup
          deleteMutation={DELETE_NOTE_MUTATION}
          form="edit-customer-note-form"
          refetchQueries={["ALL_NOTES_QUERY"]}
          variables={{ where: { RecId: note.RecId } }}
          onComplete={onComplete}
        />
      </Fieldset>
    </form>
  );
};

EditCustomerNoteForm.propTypes = {
  note: PropTypes.object,
  onComplete: PropTypes.func
};

export default EditCustomerNoteForm;
